"use strict";

var _lodash = require("lodash");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var OrgEntitlementProductBlock = /*#__PURE__*/function () {
  OrgEntitlementProductBlock.$inject = ["entitlementsService"];
  /* @ngInject */
  function OrgEntitlementProductBlock(entitlementsService) {
    _classCallCheck(this, OrgEntitlementProductBlock);
    this.entitlementsService = entitlementsService;
  }

  /**
   * For product, return product usage percentage
   * @return {Number}
   */
  return _createClass(OrgEntitlementProductBlock, [{
    key: "getUsagePercentage",
    value: function getUsagePercentage() {
      var maxValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
      var _this$product = this.product,
        multiple = _this$product.multiple,
        _this$product$usage = _this$product.usage,
        available = _this$product$usage.available,
        used = _this$product$usage.used;
      var rawValue = 0;

      // if nothing is available, or worth, negative availability
      // then return Infinity (overage)
      if (available <= 0) {
        rawValue = used || used > 0 ? Infinity : 0;
      } else {
        if (multiple) {
          rawValue = 100 - (available - used) / available * 100;
        } else {
          // if not multiple
          if (available && used) {
            rawValue = 100;
          }
          // else default: available but not used, 0
        }
      }
      return Math.min(rawValue, maxValue);
    }

    /**
     * CSS Class for product
     * @return {String}
     */
  }, {
    key: "getUsageClass",
    value: function getUsageClass() {
      var percentageUsage = this.getUsagePercentage();
      var classes = [];
      if (this.canBeAdded) {
        classes.push('usage-can-be-added');
      }
      if (this.product.usage.error) {
        classes.push('usage-error');
      } else {
        if (this.product.multiple) {
          if (percentageUsage <= 100) {
            classes.push('usage-ok');
          } else if (percentageUsage <= 110) {
            classes.push('usage-warn');
          } else {
            classes.push('usage-ko');
          }
        } else {
          if (percentageUsage === 0) {
            classes.push('usage-available');
          } else if (percentageUsage === 100) {
            classes.push('usage-used');
          } else {
            classes.push('usage-ko');
          }
        }
      }
      return classes.join(' ');
    }

    /**
     * Icon class based on product type
     * @return {String}
     */
  }, {
    key: "getProductIconClass",
    value: function getProductIconClass() {
      var iconHash = {
        package: 'icon-box',
        subscription: 'icon-users',
        unmapped: 'icon-question-sign'
      };
      return iconHash[this.product.type];
    }

    /**
     * Handles add button click
     * @param {Event} $event
     */
  }, {
    key: "handleAddButtonClick",
    value: function handleAddButtonClick($event) {
      $event.stopImmediatePropagation();
      if (!this.canBeAdded) {
        return;
      }
      this.onAdd(this.product);
    }

    /**
     * Handles settle button click
     * @param {Event} $event
     */
  }, {
    key: "handleSettleButtonClick",
    value: function handleSettleButtonClick($event) {
      $event.stopImmediatePropagation();
      if (this.canBeSettled && this.onSettle) {
        this.onSettle(this.product);
      }
    }

    /**
     * Checks if there are a given product is a subscription and is not empty
     * @param {Object} product
     * @return {Boolean}
     */
  }, {
    key: "hasSubscriptions",
    value: function hasSubscriptions(product) {
      if (!product.multiple || !product.usage || !product.usage.details) return;
      var usageDetails = product.usage.details;
      return usageDetails.nofNotSpotmePax + usageDetails.nofCancelledActivedNotSpotme > 0;
    }

    /**
     * Returns a formated string representing info on how the subscriptions are counted
     * @param {Object} usageDetails
     * @return {String}
     */
  }, {
    key: "formatUsageDetails",
    value: function formatUsageDetails(usageDetails) {
      if (!usageDetails) {
        return;
      }
      var nofNotSpotmePax = usageDetails.nofNotSpotmePax,
        nofCancelledNotSpotmePax = usageDetails.nofCancelledNotSpotmePax,
        nofCancelledActivedNotSpotme = usageDetails.nofCancelledActivedNotSpotme,
        nofSpotmePax = usageDetails.nofSpotmePax,
        nofSubscriptions = usageDetails.nofSubscriptions,
        nofCancelledPaxWithinDuration = usageDetails.nofCancelledPaxWithinDuration,
        nofTestUsers = usageDetails.nofTestUsers,
        nofExpiredUsers = usageDetails.nofExpiredUsers;
      var pax = '';
      var cancelledPax = '';
      var cancelledActivatedPax = '';
      var cancelledPaxOutsideDuration = '';
      var testUsers = '';
      var expiredUsers = '';
      if (nofNotSpotmePax > 0) {
        pax = "".concat(nofNotSpotmePax, " ").concat(nofNotSpotmePax === 1 ? 'user' : 'users');
      }
      if (nofExpiredUsers) {
        expiredUsers = " - ".concat(nofExpiredUsers, " expired ").concat(nofExpiredUsers === 1 ? 'user' : 'users');
      }
      if (!this.entitlementsV2) {
        if (nofCancelledNotSpotmePax > 0) {
          cancelledPax = " - ".concat(nofCancelledNotSpotmePax, " cancelled ").concat(nofCancelledNotSpotmePax === 1 ? 'user' : 'users');
        }
        if (nofCancelledActivedNotSpotme > 0) {
          cancelledActivatedPax = " + ".concat(nofCancelledActivedNotSpotme, " cancelled activated ").concat(nofCancelledActivedNotSpotme === 1 ? 'user' : 'users');
        }
      } else {
        // nofCancelledPaxWithinDuration can be false if there is
        // no duration available for the calculation
        if (nofCancelledNotSpotmePax > 0 && nofCancelledPaxWithinDuration !== false) {
          var nofCancelledPaxOutsideDuration = nofCancelledNotSpotmePax - nofCancelledPaxWithinDuration;
          if (nofCancelledPaxOutsideDuration) {
            cancelledPaxOutsideDuration = " - ".concat(nofCancelledPaxOutsideDuration, " cancelled ").concat(nofCancelledPaxOutsideDuration === 1 ? 'user' : 'users');
          }
        }
        if (nofTestUsers) {
          testUsers = " - ".concat(nofTestUsers, " test ").concat(nofTestUsers === 1 ? 'user' : 'users');
        }
      }
      return "".concat(pax).concat(cancelledPax).concat(cancelledActivatedPax).concat(cancelledPaxOutsideDuration).concat(testUsers).concat(expiredUsers, " = ").concat(nofSubscriptions, " ").concat(nofSubscriptions === 1 ? 'subscription' : 'subscriptions', ".").concat(nofSpotmePax ? " (".concat(nofSpotmePax, " SpotMe ").concat(nofSpotmePax === 1 ? 'user' : 'users', " filtered).") : '');
    }

    /**
     * Should show settle button in this product block?
     * @return {Boolean}
     */
  }, {
    key: "showSettleButton",
    value: function showSettleButton() {
      var isOverUsage = (0, _lodash.get)(this.product, 'usage.available', 0) - (0, _lodash.get)(this.product, 'usage.used', 0) < 0;
      return this.canBeSettled && isOverUsage;
    }
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-entitlement-product-block', ['backstage.services']).component('bsOrgEntitlementProductBlock', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlement-product-block/org-entitlement-product-block.html',
  bindings: {
    product: '<',
    loading: '<',
    indicatorIcon: '<',
    canBeAdded: '<',
    canBeSettled: '<',
    entitlementsV2: '<',
    showGauge: '@',
    textOnly: '@',
    onAdd: '&',
    onSettle: '&'
  },
  controllerAs: 'vm',
  controller: OrgEntitlementProductBlock
}).name;